import { api } from './apiClient';

export function getSetting(key: string) {
  return api.get<{ key: string; value: string; isDefault: boolean }>(`/settings/${key}`);
}
export function putSetting(key: string, value: string) {
  return api.put<{ key: string; value: string }>(`/settings/${key}`, { value });
}
